import {MapControl, MapControlProps, withLeaflet} from 'react-leaflet';
import {BoundingBox} from '../../domain'
import L from "leaflet";

interface ExitGeometryEditorButtonProps extends MapControlProps {
    exitGeometryEditor: (bbox: BoundingBox) => void
}
class ExitGeometryEditorButton extends MapControl<ExitGeometryEditorButtonProps, L.Control.EasyButton> {
    createLeafletElement(props: ExitGeometryEditorButtonProps): L.Control.EasyButton {
        return L.easyButton('fas fa-window-close',
            () => this.props.exitGeometryEditor(this.getBoundingBox()),
            'Avbryt geometriredigering',
            'exitGeometryEditorButton'
        );
    }

    getBoundingBox() {
        let bbox = this.props.leaflet.map.getBounds();

        return new BoundingBox(
            bbox.getNorthEast(),
            bbox.getSouthWest(),
            '4326');
    }
}

export default withLeaflet(ExitGeometryEditorButton);

